import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { zohoApi } from '../services/api';

/**
 * Recherche de clients Books côté SERVEUR.
 *
 * La liste complète ne peut pas servir de référentiel d'écran : l'organisation
 * compte plus de dix mille clients (la synchronisation CRM en crée un par
 * compte), et notre pagination s'arrêtait au garde-fou de 10 000. Comme Zoho
 * rend les contacts par ordre alphabétique, tout ce qui suivait la lettre I
 * était invisible — d'où un client bien réel introuvable dans le sélecteur.
 *
 * On interroge donc Zoho à la frappe, et il ne revient que les vingt premiers
 * résultats.
 */
export function useZohoCustomersSearch(query: string, enabled = true) {
  const q = query.trim();
  return useQuery({
    queryKey: ['zoho-customers-search', q],
    queryFn: () => zohoApi.searchCustomers(q),
    // Zoho ignore les recherches d'une seule lettre : inutile de l'appeler.
    enabled: enabled && q.length >= 2,
    staleTime: 60_000,
  });
}

/** Attend que la frappe se calme avant de lancer la recherche. */
export function useDebounce<T>(valeur: T, delaiMs: number): T {
  const [differee, setDifferee] = useState(valeur);
  useEffect(() => {
    const t = setTimeout(() => setDifferee(valeur), delaiMs);
    return () => clearTimeout(t);
  }, [valeur, delaiMs]);
  return differee;
}
